import React from 'react';
import ReactDOM from 'react-dom';
import Example from './Example';

ReactDOM.render(
  <React.StrictMode>
    <Example />
  </React.StrictMode>,
  document.getElementById('hi-react')
);